import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IJeAccrualYearMonthFiltersState } from "./interfaces";
import { getYearMonthForUseTaxCalculationFilter } from "utils";

const yearMonth = getYearMonthForUseTaxCalculationFilter();
const initialState: IJeAccrualYearMonthFiltersState = {
  year: yearMonth[0],
  month: yearMonth[1],
};

export const jeAccrualYearMonthFiltersSlice = createSlice({
  name: "jeAccrualYearMonthFilters",
  initialState,
  reducers: {
    updateYear: (state, action: PayloadAction<number>) => {
      state.year = action.payload;
    },
    updateMonth: (state, action: PayloadAction<string>) => {
      state.month = action.payload;
    },
  },
});

export const { updateYear, updateMonth } =
  jeAccrualYearMonthFiltersSlice.actions;

export default jeAccrualYearMonthFiltersSlice.reducer;
